import React from 'react';
import ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
// axe-core: dev-only, dynamic import (no static import)
// Note: React must be default import so axe can patch createElement (namespace import is read-only)
if (process.env.NODE_ENV === 'development') {
    import('@axe-core/react').then((axe) => {
        axe.default(React, ReactDOM, 1000);
    });
}
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
if (!document.title.trim()) {
    document.title = 'City of Grand Prairie Code Compliance';
}
ReactDOM.render(<App config={config}/>, target);
